import React, { useState, useEffect } from "react";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import { FaStar } from "react-icons/fa";
import CryptoJS from 'crypto-js';
import LOGO_MIN from '../../assets/images/logo-sm.png';
import { useLocation, useParams } from "react-router-dom";
import axiosInstance from "pages/Utility/axiosInstance";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from 'yup';
import { showSuccess } from "helpers/notification_helper";

const AddFeedBack = () => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [comment, setComment] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const wid = queryParams.get("wid"); 
  const tid = queryParams.get("tid");


  const { id } = useParams();
  console.log(id);

  // Yup validation schema
  const validationSchema = Yup.object({
    rating: Yup.number(),
    comment: Yup.string()
      .max(500, "Comment can't exceed 500 characters")
      .required("Please leave your feedback"),
  });

  const handleSubmit = async (values,{resetForm}) => {
    try {
      const response = await axiosInstance.post("", {
        sp: "usp_InsertFeedback",
        workOrderId:decodeBase64(wid),
        teamId: decodeBase64(tid),
        rating: values.rating,
        comments: values.comment,
      });
      if(response){
        resetForm();
        showSuccess("Feedback submitted Successfully")
      }
    } catch (error) {
      console.log(error);
    }
  };

  // Decode Base64 function
  function decodeBase64(base64String) {
    const base64UrlSafe = base64String.replace(/-/g, "+").replace(/_/g, "/");
    const padding = base64UrlSafe.length % 4 === 0 ? "" : "=".repeat(4 - (base64UrlSafe.length % 4));
    const base64WithPadding = base64UrlSafe + padding;

    try {
      const decodedString = atob(base64WithPadding);

      const byteArray = new Uint8Array(decodedString.length);
      for (let i = 0; i < decodedString.length; i++) {
        byteArray[i] = decodedString.charCodeAt(i);
      }

      try {
        return new TextDecoder().decode(byteArray);
      } catch (e) {
        return byteArray;
      }
    } catch (error) {
      console.error("Error decoding Base64 string:", error);
      throw new Error("Invalid Base64 string.");
    }
  }


  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
      <Formik
        initialValues={{
          rating: 0,
          comment: "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, values, errors, touched }) => (
          <FormikForm
            className="p-4 border rounded mx-3 bg-white"
            style={{ minWidth: "300px", width: "600px", maxWidth: "500px" }}
          >
            <div className="d-flex justify-content-center align-items-center mb-3">
              <img src={LOGO_MIN} width="70px" />
            </div>
            <h4 className="text-center">Feedback Form</h4>

            {/* Star Rating */}
            <FormGroup>
              <label className="mb-0">Rate Us <span className="text-danger">*</span></label>
              <div className="d-flex align-items-center mt-0">
                {[1,2,3,4,5,6,7,8,9,10].map((star,index) => (
                  <div className="mt-0">
                    <FaStar
                      key={star}
                      size={24}
                      className="me-1"
                      onClick={() => setFieldValue("rating", star)}
                      onMouseEnter={() => setHover(star)}
                      onMouseLeave={() => setHover(null)}
                      color={star <= (hover || values.rating) ? "#ffc107" : "#e4e5e9"}
                      style={{ cursor: "pointer", marginTop: `${index === 0 ?"24px": index===9 ?"24px":0}` }}
                    />
                    <p>{index === 0 ? "Poor": index ===9 ? "Excellent":''}</p>
                  </div>
                  
                ))}
              </div>
              
            </FormGroup>

            {/* Comment Section */}
            <FormGroup>
              <Label for="comment">Comment <span className="text-danger">*</span></Label>
              <Field
                as={Input}
                type="textarea"
                id="comment"
                name="comment"
                placeholder="Leave your feedback here..."
                rows="4"
                className={touched.comment && errors.comment ? "is-invalid" : ""}
              />
              <ErrorMessage name="comment" component="div" className="text-danger" />
            </FormGroup>

            {/* Submit Button */}
            <div className="text-center">
              <Button color="primary" type="submit">
                Submit Feedback
              </Button>
            </div>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
};

export default AddFeedBack;
